__turbopack_context__.v({
  "user-company": "CompanyName-module-scss-module__k3WMRW__user-company",
  "user-company-container": "CompanyName-module-scss-module__k3WMRW__user-company-container",
});
